import type { ExecutorDto } from '@app/api/routes/executors/dtos'
import type { SelectFc } from '@app/types/QueryOptions'
import type { FilterOption } from '@app/types/filter'

export const getFilterFromExecutors: SelectFc<FilterOption, ExecutorDto> = executorsResponse =>
  executorsResponse?.map(({ id, firstName, lastName }) => ({
    value: id,
    label: `${firstName} ${lastName}`
  })) ?? []
